import { appid } from '@/config'
import { queryToStr } from '@/utils/common'

let key = 'applicantInfo'
export default {
    namespaced: true,
    state: {
        applicantInfo: JSON.parse(sessionStorage.getItem(key)) || {}
    },
    getters: {
        isLogin: (state) => {
            return !!state.applicantInfo.token
        }
    },
    mutations: {
        SET_APPLICANT_INFO: (state, info) => {
            state.applicantInfo = info
            sessionStorage.setItem(key, JSON.stringify(info))
        }
    },
    actions: {
        checkLogin({ getters, state }, to) {
            return new Promise((resolve) => {
                if(getters.isLogin) {
                    // 已登录但手机号明确未绑定的，必须先完成绑定才能进入内部页
                    // （防止绑定失败后带 token 直接进入 /interview 等内部页）
                    const info = state.applicantInfo
                    const phoneUnbound = info.bindPhone === 0 || info.bindPhone === '0'
                    if (phoneUnbound) {
                        resolve({
                            path: '/bindMobile',
                            query: {
                                scene: 'wechat-login',
                                openId: info.openId || '',
                                redirect: to.path + queryToStr(to.query),
                                from: 'interview'
                            }
                        })
                    } else {
                        resolve()
                    }
                } else {
                    const target = to.path + queryToStr(to.query)
                    // 非微信环境（本地开发 / PC 浏览器）下微信 OAuth 无法回调到当前域名，
                    // 登录失败回退到首页
                    const isWechat = /MicroMessenger/i.test(navigator.userAgent)
                    if (!isWechat) {
                        resolve('/')
                        return
                    }
                    let path = encodeURIComponent(location.origin+'/#/wechatLogin')
                    let state = encodeURIComponent(target)
                    location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${path}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
                }
            })
        }
    }
}
